export enum PostMessageKey {
    WEBINAR_STARTED = 'webinar-started',
    WEBINAR_ENDED = 'webinar-ended'
}